import { unescapeMarkdownLinkText } from '#pplx/frontend/common/markdownTitle.js';
import { getMentionLinkMarkdown, unescapeMarkdownLinkTitle, } from '#pplx/frontend/composer-sdk/lexical/utils/getMentionLinkMarkdown.js';
import { $createLinkNode, $isAutoLinkNode, $isLinkNode, LinkNode } from '@lexical/link';
import { $createTextNode } from 'lexical';
function getUnescapedCharacterIndices({ value, character, }) {
    const indices = [];
    let precedingBackslashes = 0;
    for (let index = 0; index < value.length; index += 1) {
        const current = value[index];
        if (current === character && precedingBackslashes % 2 === 0)
            indices.push(index);
        precedingBackslashes = current === '\\' ? precedingBackslashes + 1 : 0;
    }
    return indices;
}
/**
 * Link transformer that converts markdown links [text](url) to LinkNodes.
 * This is equivalent to the LINK transformer from @lexical/markdown.
 */
export const LINK_TRANSFORMER = {
    dependencies: [LinkNode],
    export: (node, exportChildren) => {
        if (!$isLinkNode(node) || $isAutoLinkNode(node)) {
            return null;
        }
        const title = node.getTitle();
        const textContent = exportChildren(node);
        return getMentionLinkMarkdown(textContent, node.getURL(), title ?? undefined) ?? textContent;
    },
    // Regex for importing markdown links: [text](url) or [text](url "title")
    importRegExp: /(?:\[(.*?)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,
    // Regex for shortcuts (must be at end of text): [text](url)$
    regExp: /(?:\[(.*?)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
    replace: (textNode, match) => {
        const [, linkText, linkUrl, linkTitle] = match;
        if (!linkUrl) {
            return;
        }
        const linkNode = $createLinkNode(linkUrl, {
            title: linkTitle ? unescapeMarkdownLinkTitle(linkTitle) : undefined,
        });
        // Handle nested brackets in link text
        const rawLinkText = linkText ?? '';
        const openBracketIndices = getUnescapedCharacterIndices({ value: rawLinkText, character: '[' });
        const closeBracketAmount = getUnescapedCharacterIndices({
            value: rawLinkText,
            character: ']',
        }).length;
        let parsedLinkText = linkText;
        let outsideLinkText = '';
        if (openBracketIndices.length < closeBracketAmount) {
            return;
        }
        else if (openBracketIndices.length > closeBracketAmount) {
            const nestedLinkStart = openBracketIndices[0] ?? 0;
            outsideLinkText = `[${rawLinkText.slice(0, nestedLinkStart)}`;
            parsedLinkText = rawLinkText.slice(nestedLinkStart + 1);
        }
        const linkTextNode = $createTextNode(unescapeMarkdownLinkText(parsedLinkText ?? ''));
        linkTextNode.setFormat(textNode.getFormat());
        linkNode.append(linkTextNode);
        if (outsideLinkText) {
            const outsideTextNode = $createTextNode(outsideLinkText);
            outsideTextNode.setFormat(textNode.getFormat());
            textNode.insertBefore(outsideTextNode);
        }
        textNode.replace(linkNode);
        return linkTextNode;
    },
    trigger: ')',
    type: 'text-match',
};
//# sourceMappingURL=linkTransformer.js.map